"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompositionLockedByAnotherUserToast = exports.getAccessRejectedToast = exports.getAccessGrantedToast = exports.getAccessRequestedToast = exports.getAccessPassedToast = void 0;

var _constants = require("composer-lib/lib/constants");

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _react = _interopRequireDefault(require("react"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var generateToastData = (0, _memoize.default)(function (lock, users, onClose) {
  var lockedBy = lock.lockedBy;
  var titleText;
  var user = users.data.get(lockedBy);

  if (user) {
    var firstName = user.firstName,
        lastName = user.lastName;
    titleText = _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.lockToast.titleText",
      options: {
        formattedName: (0, _formatName.default)({
          firstName: firstName,
          lastName: lastName
        })
      }
    });
  } else {
    titleText = _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.lockToast.unknownUserTitleText"
    });
  }

  var toastData = (0, _immutable.Map)({
    key: _constants.LOCK_TOAST_ID,
    toast: (0, _immutable.Map)({
      onClose: onClose,
      textI18n: 'composer-lib.lockToast.message',
      titleI18n: titleText,
      type: 'info'
    })
  });
  return toastData;
}, function (lock, users) {
  return lock.hashCode() + users.hashCode();
});
var generateAccessPassedToast = (0, _memoize.default)(function (locker, users, onClose) {
  var _parseUser = (0, _userHelpers.parseUser)(locker, users),
      firstName = _parseUser.firstName,
      lastName = _parseUser.lastName;

  var titleText = _react.default.createElement(_FormattedMessage.default, {
    message: "composer-lib.accessPassedToast.titleText",
    options: {
      formattedName: (0, _formatName.default)({
        firstName: firstName,
        lastName: lastName
      })
    }
  });

  return (0, _immutable.Map)({
    key: "accessPassedToast" + locker,
    toast: (0, _immutable.Map)({
      fadeAway: true,
      onClose: onClose,
      opts: {
        firstName: firstName,
        lastName: lastName
      },
      textI18n: 'composer-lib.accessPassedToast.message',
      titleI18n: titleText,
      type: 'info'
    })
  });
}, function (locker, users) {
  return locker + users.hashCode();
});
var generateAccessRequestedToast = (0, _memoize.default)(function (locker, users) {
  var _parseUser2 = (0, _userHelpers.parseUser)(locker, users),
      firstName = _parseUser2.firstName,
      lastName = _parseUser2.lastName;

  var titleText = _react.default.createElement(_FormattedMessage.default, {
    message: "composer-lib.accessRequestedToast.titleText"
  });

  return (0, _immutable.Map)({
    key: "accessRequestedToast" + locker,
    toast: (0, _immutable.Map)({
      fadeAway: true,
      opts: {
        firstName: firstName,
        lastName: lastName
      },
      textI18n: 'composer-lib.accessRequestedToast.message',
      titleI18n: titleText,
      type: 'info'
    })
  });
}, function (locker, users) {
  return locker + users.hashCode();
});

var generateAccessGrantedToast = function generateAccessGrantedToast() {
  var titleText = _react.default.createElement(_FormattedMessage.default, {
    message: "composer-lib.accessGrantedToast.titleText"
  });

  return (0, _immutable.Map)({
    key: _constants.ACCESS_GRANTED_TOAST_ID,
    toast: (0, _immutable.Map)({
      fadeAway: true,
      textI18n: 'composer-lib.accessGrantedToast.message',
      titleI18n: titleText,
      type: 'info'
    })
  });
};

var generateAccessRejectedToast = (0, _memoize.default)(function (locker, users) {
  var _parseUser3 = (0, _userHelpers.parseUser)(locker, users),
      firstName = _parseUser3.firstName,
      lastName = _parseUser3.lastName;

  var titleText = _react.default.createElement(_FormattedMessage.default, {
    message: "composer-lib.accessRejectedToast.titleText",
    options: {
      formattedName: (0, _formatName.default)({
        firstName: firstName,
        lastName: lastName
      })
    }
  });

  return (0, _immutable.Map)({
    key: "accessRejectedToast" + locker,
    toast: (0, _immutable.Map)({
      fadeAway: true,
      opts: {
        firstName: firstName,
        lastName: lastName
      },
      textI18n: 'composer-lib.accessRejectedToast.message',
      titleI18n: titleText,
      type: 'warning'
    })
  });
}, function (locker, users) {
  return locker + users.hashCode();
}); // Needs `hideAccessPassedToast` function

var getAccessPassedToast = function getAccessPassedToast(_ref) {
  var composition = _ref.composition,
      hideAccessPassedToast = _ref.hideAccessPassedToast,
      presence = _ref.presence,
      toastData = _ref.toastData,
      users = _ref.users;
  var accessPassedToast = presence.accessPassedToast;

  if (composition.isReadOnly() || !accessPassedToast) {
    return null;
  }

  var toast = generateAccessPassedToast(accessPassedToast, users, hideAccessPassedToast);
  var key = toast.get('key');

  if ((0, _immutable.is)(toastData.get(key), toast)) {
    return toast;
  }

  return null;
};

exports.getAccessPassedToast = getAccessPassedToast;

var getAccessRequestedToast = function getAccessRequestedToast(_ref2) {
  var composition = _ref2.composition,
      presence = _ref2.presence,
      toastData = _ref2.toastData,
      users = _ref2.users;
  var locker = presence.locker,
      requestedAccess = presence.requestedAccess;

  if (composition.isReadOnly() || !requestedAccess) {
    return null;
  }

  var toast = generateAccessRequestedToast(locker, users);
  var key = toast.get('key');

  if (!(0, _immutable.is)(toastData.get(key), toast)) {
    return toast;
  }

  return null;
};

exports.getAccessRequestedToast = getAccessRequestedToast;

var getAccessGrantedToast = function getAccessGrantedToast(_ref3) {
  var auth = _ref3.auth,
      composition = _ref3.composition,
      presence = _ref3.presence,
      toastData = _ref3.toastData;
  var locker = presence.locker;
  var userId = auth.user.get('user_id');

  if (composition.isReadOnly() || locker !== userId) {
    return null;
  }

  var key = _constants.ACCESS_GRANTED_TOAST_ID;

  if (toastData.has(key)) {
    return null;
  }

  var toast = generateAccessGrantedToast();

  if (!(0, _immutable.is)(toastData.get(key), toast)) {
    return toast;
  }

  return null;
};

exports.getAccessGrantedToast = getAccessGrantedToast;

var getAccessRejectedToast = function getAccessRejectedToast(_ref4) {
  var composition = _ref4.composition,
      presence = _ref4.presence,
      toastData = _ref4.toastData,
      users = _ref4.users;
  var locker = presence.locker,
      requestRejected = presence.requestRejected;

  if (composition.isReadOnly() || !requestRejected) {
    return null;
  }

  var toast = generateAccessRejectedToast(locker, users);
  var key = toast.get('key');

  if (!(0, _immutable.is)(toastData.get(key), toast)) {
    return toast;
  }

  return null;
}; // Needs `hideCompositionLockToast` function


exports.getAccessRejectedToast = getAccessRejectedToast;

var getCompositionLockedByAnotherUserToast = function getCompositionLockedByAnotherUserToast(_ref5) {
  var auth = _ref5.auth,
      composition = _ref5.composition,
      hideCompositionLockToast = _ref5.hideCompositionLockToast,
      lock = _ref5.lock,
      toastData = _ref5.toastData,
      users = _ref5.users;
  var toastDismissed = lock.toastDismissed;
  var lockedByAnother = (0, _lockHelpers.compositionLockedByAnotherUser)(lock, auth);

  if (composition.isReadOnly() || !lockedByAnother || toastDismissed) {
    return null;
  }

  var toast = generateToastData(lock, users, hideCompositionLockToast);
  var key = toast.get('key');

  if (!(0, _immutable.is)(toastData.get(key), toast)) {
    return toast;
  }

  return null;
};

exports.getCompositionLockedByAnotherUserToast = getCompositionLockedByAnotherUserToast;